
export function unixToDate (unix, format) {
  if (!unix) return unix
  let _format = format || 'yyyy-MM-dd'
  const d = new Date(unix)
  const o = {
    'M+': d.getMonth() + 1,
    'd+': d.getDate(),
    'h+': d.getHours(),
    'm+': d.getMinutes(),
    's+': d.getSeconds(),
    'q+': Math.floor((d.getMonth() + 3) / 3),
    S: d.getMilliseconds()
  }
  if (/(y+)/.test(_format)) _format = _format.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (const k in o) if (new RegExp('(' + k + ')').test(_format)) _format = _format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  return _format
}
export function channelShortName (value) {
  if (value === 'tender_bulletin') {
    return '招标公告'
  } else if (value === 'change_bulletin') {
    return '变更公告'
  } else if (value === 'clarify_bulletin') {
    return '答疑澄清'
  } else if (value === 'win_candidate_bulletin') {
    return '中标候选人公示'
  } else if (value === 'winbid_bulletin') {
    return '中标公告'
  } else {
    return '废标公告'
  }
}



// WEBPACK FOOTER //
// ./src/filter/index.js